import { Injectable } from '@angular/core';
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { AdditionalWorkReportDataService } from '../data-services/additional-work-report-data.service';
import { AdditionalWorkRequestModel } from '../business-entities/additional-work-report.model';

@Injectable({
  providedIn: 'root'
})
export class AdditionalWorkReportService {

  additionalWorkRequestModel: AdditionalWorkRequestModel = {
    dealerId: '',
    selectedDate: '',
    status: 0,
    startRecordNumber: 0,
    pageSize: 25,
    sortColumn: '',
    sortDirection: 'desc',
    isExport: false,
  };

  constructor(private additionalWorkReportDataService: AdditionalWorkReportDataService) { }

  async GetAdditionalWorkList(requestModel: AdditionalWorkRequestModel): Promise<GenericResponse<any>> {
    return this.additionalWorkReportDataService.getAdditionalWorkList(requestModel);
  }
}